import styled from "styled-components";
import { device } from "../../../../helpers/breakpoints";

export const SideNavItem = styled.div`
  height: 4.678rem;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0.938rem 1rem;
  color: ${(props) => (props.active ? "#1a5304" : "#525A6E")};
  background: ${(props) => (props.active ? "#FAFAFA" : "#EDF0F4")};
  box-shadow: ${(props) =>
    props.active
      ? "0 3.75rem 4rem rgba(101, 101, 101, 0.04), 0 0.5rem 0.5rem rgba(101, 101, 101, 0.02)"
      : ""};
  border-radius: 0.25rem;
  cursor: pointer;

  & > svg.icon {
    height: 1.125rem;
    width: 1.25rem;
    stroke: ${(props) => (props.active ? "#1a5304" : "#525A6E")};
  }
  & img {
    height: 2.5rem;
    width: 2.5rem;
    stroke: ${(props) => (props.active ? "#1a5304" : "#525A6E")};
  }
  margin-bottom: 1rem;

  &:hover {
    background: #ffffff;
  }
`;

export const ImageDiv = styled.div`
  width: 50%;
`;

export const ImageContainer = styled.div`
  border: 1px solid grey;
  border-radius: 50%;
  padding: 0.5rem;
`;

export const ContentContainer = styled.div`
  margin-left: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media ${device.tablet} {
    display: none;
  }
`;

export const NameDiv = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1rem;
  font-weight: 600;
  text-transform: capitalize;
`;

export const NewMessageDiv = styled.div`
  color: #1a5304;
`;
